var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 917.492,
    height: 346.281,
    viewBox: "0 0 917.492 346.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b7dbcb;}.b{fill:#99cfbe;}.c{fill:#b1b1b1;}.d{opacity:0.1;}.e{fill:#2f2e41;}.f{fill:#3f3d56;}.g{fill:#f2f2f2;}.h{fill:#9f9f9f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-369.174 -123.239)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 188.719,
    cy: 25.674,
    rx: 188.719,
    ry: 25.674,
    transform: "translate(369.174 418.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-326.172-139.062l17.383-145.312h166.211V-233.2h-112.7l-6.445,56.445a77.841,77.841,0,0,1,18.457-7.227,84.557,84.557,0,0,1,22.363-3.125q42.383,0,65.137,25.1t22.754,70.41q0,27.344-12.207,49.512A83.9,83.9,0,0,1-179.492-8.008q-22.07,11.914-52.148,11.914a116.362,116.362,0,0,1-50.2-11.035Q-305.273-18.164-318.555-37.4a73.6,73.6,0,0,1-13.086-43.457h66.016q.977,15.625,9.961,24.8t23.633,9.18q33.2,0,33.2-49.219,0-45.508-40.625-45.508-23.047,0-34.375,14.844Zm425.2,22.852q0,57.617-25.879,88.867T.2,3.906q-47.461,0-73.437-31.445t-25.977-88.672v-51.953q0-57.617,25.879-88.867T-.2-288.281q47.266,0,73.242,31.445t25.977,88.867ZM33.2-176.562q0-30.664-8.008-45.8T-.2-237.5q-16.992,0-24.707,14.063t-8.3,42.578V-108.2q0,31.836,8.008,46.582T.2-46.875q16.8,0,24.8-14.355t8.2-45.02Zm297.461,60.352q0,57.617-25.879,88.867T231.836,3.906q-47.461,0-73.437-31.445t-25.977-88.672v-51.953q0-57.617,25.879-88.867t73.145-31.25q47.266,0,73.242,31.445t25.977,88.867Zm-65.82-60.352q0-30.664-8.008-45.8T231.445-237.5q-16.992,0-24.707,14.063t-8.3,42.578V-108.2q0,31.836,8.008,46.582t25.391,14.746q16.8,0,24.8-14.355t8.2-45.02Z",
    transform: "translate(956.002 411.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M800.4,662.73l-5.253,33.539s-25.862,13.739-7.678,14.143,103.851,0,103.851,0,16.568,0-9.7-14.547l-5.253-35.156Z",
    transform: "translate(-281.119 -283.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M783.812,710.049c4.13-3.675,11.336-7.5,11.336-7.5l5.253-33.539,75.969.071,5.253,33.064c6.125,3.392,9.919,5.993,12.139,7.988,3.374-.77,7.06-3.63-12.139-14.263L876.37,660.71,800.4,662.73l-5.253,33.539S773.417,707.816,783.812,710.049Z",
    transform: "translate(-281.122 -283.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M12.034,0h318.2a12.034,12.034,0,0,1,12.034,12.034V226.378a12.034,12.034,0,0,1-12.034,12.034H12.034A12.034,12.034,0,0,1,0,226.378V12.034A12.034,12.034,0,0,1,12.034,0Z",
    transform: "translate(385.728 145.224)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 319.23,
    height: 178.607,
    transform: "translate(397.245 157.953)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 2.02,
    cy: 2.02,
    r: 2.02,
    transform: "translate(554.839 150.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M952.087,621.322v20.9a12.032,12.032,0,0,1-12.035,12.034H621.858a12.033,12.033,0,0,1-12.034-12.035v-20.9Z",
    transform: "translate(-224.096 -270.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M860.368,660.2v4.041h-217.4v-3.233l.3-.808,5.358-14.547h207.3Z",
    transform: "translate(-214.205 -211.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1095.336,755.082c-.4,1.693-1.891,3.479-5.269,5.168-12.123,6.061-36.772-1.616-36.772-1.616S1034.3,755.4,1034.3,746.916a15.146,15.146,0,0,1,1.665-.99c5.1-2.7,22-9.35,51.959.282a12.5,12.5,0,0,1,5.7,3.732A5.96,5.96,0,0,1,1095.336,755.082Z",
    transform: "translate(-365.511 -310.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1096.168,755.082c-14.838,5.686-28.064,6.11-41.637-3.318-6.845-4.752-13.064-5.928-17.731-5.839,5.1-2.7,22-9.35,51.959.282a12.5,12.5,0,0,1,5.7,3.732A5.96,5.96,0,0,1,1096.168,755.082Z",
    transform: "translate(-366.343 -310.546)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "g",
    cx: 5.253,
    cy: 1.616,
    rx: 5.253,
    ry: 1.616,
    transform: "translate(705.968 437.986)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.678,
    cy: 7.678,
    r: 7.678,
    transform: "translate(549.182 359.593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M860.368,667.466v4.041h-217.4v-3.233l.3-.808Z",
    transform: "translate(-214.205 -218.974)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.599d44ef832b77b0bd6cb97703557a37.svg";
export { ForwardRef as ReactComponent };